import { BasketCartUrl } from "../directives/utilities/urls";

export default function enrollmentVerification() {
    return {
        isClearBalancePaymentBasket: false,
        isCandidacyVerification: false,
        candidacyVerificationFalseMessage: '',
        checkOutMessage:'',
        eValue: '',
        transcript: [],
        isSendEmail: true,
        message: '',
        passedSessionId: '',
        passedBasketId: '',
        passedName: '',
        passedAddress1: '',
        passedAddress2: '',
        passedAddress3: '',
        passedCity: '',
        passedState: '',
        passedCountry: '',
        passedZipCode: '',
        passedMailComments: '',
        passedEmailComments: '',
        passedCopies: 1,
        isDeferredLoan: false,
        passedEmail: '',
        states: [],
        countries: [],
        isPassedEmailComments: false,
        isPassedEmailCommentsError: '',
        isPassedEmail: false,
        isPassedEmailError: '',
        isPassedMailComments: false,
        isPassedMailCommentsError: '',
        isPassedCountry: false,
        isPassedCountryError: '',
        isPassedZipCode: false,
        isPassedZipCodeError: '',
        isPassedState: false,
        isPassedStateError: '',
        isPassedAddress2: false,
        isPassedAddress2Error: '',
        isPassedCity: false,
        isPassedCityError: '',
        isPassedAddress1: false,
        isPassedAddress1Error: '',
        isPassedName: false,
        isPassedNameError: '',
        isSuccessMessage: false,
        isEnrollmentRequestType: false,
        isEnrollmentRequestTypeError: '',
        enrollmentRequestType: '',
        birthdateOptionValue: false,
        ssnOptionValue: false,
        mailingAddressOptionValue: false,
        noneOptionValue: false,
        isOptionalInfo: false,
        isOptionalInfoError: '',
        namePreference: '',
        isNamePreference: false,
        isNamePreferenceError: '',
        selectedOptions: [],
        isSubmitting:false,
        isValidEmail(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        },
        ClearBalancePaymentBasket() {

            fetch('/api/Basket/ClearBalancePaymentBasket', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.isClearBalancePaymentBasket = true;
                        if (this.passedBasketId <= 0) {
                            this.CandidacyVerificationRequestCheck();
                        }
                    } else {
                        this.isClearBalancePaymentBasket = false;
                    }

                });
        },
        CandidacyVerificationRequestCheck() {

            fetch('/api/Basket/VerificationRequestCheck', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess && response.allowed) {

                        this.isCandidacyVerification = true;
                        this.candidacyVerificationFalseMessage = "";
                    } else {
                        this.isCandidacyVerification = false;
                        this.candidacyVerificationFalseMessage = response.message; //"Please complete your original request prior to completing an Enrollment Verification. <a href=\"" + BasketCartUrl + "\" class=\"text-primary\">Click here</a> to resume or cancel your original request.";

                    }

                });
        },

        GetEnrollmentTranscript() {
            this.passedEmail = document.getElementById("hdnEmail").value;
            fetch('/api/StudentAPI/GetEnrollmentTranscript', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({

                    BasketId: this.passedBasketId,
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response.isSuccess) {
                        this.transcript = response.transcript;
                        if (this.transcript != null) {
                            this.isSendEmail = this.transcript.sendEmail;
                            this.passedName = this.transcript.name;
                            this.passedAddress1 = this.transcript.addressLine1;
                            this.passedAddress2 = this.transcript.addressLine2;
                            this.passedAddress3 = this.transcript.addressLine3;
                            this.passedCity = this.transcript.city;
                            this.passedState = this.transcript.state;
                            this.passedZipCode = this.transcript.zipCode;
                            this.passedEmail = this.transcript.emailAddress;
                            this.passedCountry = this.transcript.country;
                            if (this.isSendEmail) {
                                this.passedEmailComments = this.transcript.comments;
                            }
                            else {
                                this.passedMailComments = this.transcript.comments;

                            }
                            //this.passedCopies = this.transcript.copies <= 0 ? 1 : this.transcript.copies;

                        }
                    } else {
                        this.isSuccessMessage = false;
                        this.message = "Something went wrong";
                    }

                });
        },
        getStates() {
            fetch('/api/common/getstates')
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                })
                .then((json) => {
                    this.states = json
                })
                .catch((error) => {
                    console.error(error);
                })
        },
        getCountries() {
            fetch(' /api/common/GetCountry')
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                })
                .then((json) => {
                    this.countries = json;
                    if (this.passedBasketId != "" && this.passedBasketId != null && this.passedBasketId > 0) {
                        this.isCandidacyVerification = true;
                        this.GetEnrollmentTranscript();
                    }

                })
                .catch((error) => {
                    console.error(error);
                });
        },
        deferLoanYesClick() {
            this.isDeferredLoan = true;
            this.message = "";
        },
        deferLoanNoClick() {
            this.isDeferredLoan = false;
            this.message = "";
        },
        sendEmailYesClick() {
            this.isSendEmail = true;
            this.message = "";
        },
        sendEmailNoClick() {
            this.isSendEmail = false;
            this.message = "";
        },
        birthdateOptionClick() {
            if (!this.birthdateOptionValue) {
                this.birthdateOptionValue = true;

                this.noneOptionValue = false;
            }
        },
        ssnOptionClick() {
            if (!this.ssnOptionValue) {
                this.ssnOptionValue = true;

                this.noneOptionValue = false;
            }
        },
        mailingAddressOptionClick() {
            if (!this.mailingAddressOptionValue) {
                this.mailingAddressOptionValue = true;

                this.noneOptionValue = false;
            }
        },
        noneOptionClick() {
            if (!this.noneOptionValue) {
                this.birthdateOptionValue = false;
                this.ssnOptionValue = false;
                this.mailingAddressOptionValue = false;
                this.noneOptionValue = true;
            }
        },
        enrollmentRequestTypeClick() {
            if (this.enrollmentRequestType == 1) {

                this.birthdateOptionValue = false;
                this.ssnOptionValue = false;
                this.mailingAddressOptionValue = false;
                this.noneOptionValue = false;
            }
        },
        SaveEnrollmentTranscript() {
            this.isSubmitting = true;
            this.selectedOptions = [];
            const numericValue = Number(this.enrollmentRequestType);

            if (this.birthdateOptionValue) {
                this.selectedOptions.push("Date of Birth");
            }
            if (this.ssnOptionValue) {
                this.selectedOptions.push("Last 4 digits of SSN");
            }
            if (this.mailingAddressOptionValue) {
                this.selectedOptions.push("Mailing Address on Record");
            }
            if (this.noneOptionValue) {
                this.selectedOptions.push("None");
            }
            if (this.enrollmentRequestType == "") {
                this.isEnrollmentRequestType = true;
                this.isEnrollmentRequestTypeError = "Please select enrollment request type";
                this.message = "";
                this.isSubmitting = false;
            }
            else {
                if (this.enrollmentRequestType == "1" && !this.birthdateOptionValue && !this.ssnOptionValue && !this.mailingAddressOptionValue && !this.noneOptionValue) {
                    this.isOptionalInfo = true;
                    this.isOptionalInfoError = "Please select at least one option";
                    this.message = "";
                    this.isSubmitting = false;
                }
                else {
                    this.isOptionalInfo = false;
                    this.isOptionalInfoError = "";
                }
                this.isEnrollmentRequestType = false;
                this.isEnrollmentRequestTypeError = "";
            }
            if (this.namePreference == "") {
                this.isNamePreference = true;
                this.isNamePreferenceError = "Please select name preference";
                this.message = "";
                this.isSubmitting = false;
            }
            else {
                this.isNamePreference = false;
                this.isNamePreferenceError = "";
            }
            if (this.isSendEmail) {

                if (this.passedEmail == "") {
                    this.isPassedEmail = true;
                    this.isPassedEmailError = "Please enter email";
                    this.message = "";
                    this.isSubmitting = false;
                }
                else if (!this.isValidEmail(this.passedEmail)) {
                    this.isPassedEmail = true;
                    this.isPassedEmailError = "Please enter valid email";
                    this.message = "";
                    this.isSubmitting = false;
                }
                else {
                    this.isPassedEmail = false;
                    this.isPassedEmailError = "";
                }
                if (!this.isEnrollmentRequestType && !this.isOptionalInfo && !this.isNamePreference && !this.isPassedEmail) {
                    fetch('/api/StudentAPI/SaveEnrollmentTranscript', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            RequestType: numericValue,
                            EnrollmentOptionalInfo: this.selectedOptions,
                            NamePreference: this.namePreference,
                            BasketId: this.passedBasketId,
                            Name: this.passedName,
                            Address1: "",
                            Address2: "",
                            Address3: "",
                            City: "",
                            State: "",
                            ZipCode: "",
                            Country: "",
                            Comments: this.passedEmailComments,
                            EmailAddress: this.passedEmail,
                            SendEmail: this.isSendEmail,
                        })
                    })
                        .then(response => {
                            if (response.ok) {
                                return response.json()
                            }
                        }).then(response => {
                            this.isSubmitting = false;
                            if (response.isSuccess) {
                                this.isSuccessMessage = true;
                                window.location.href = BasketCartUrl;
                            } else if (!response.isSuccess && response.checkoutTypeError) {
                                this.checkOutMessage = response.message
                                document.getElementById('btnCartCheckOutError').click();
                            } 
                        
                            else {
                                this.isSuccessMessage = false;
                                this.message = "Something went wrong";
                            }
                        });
                }
            }
            else {
                if (this.passedName == "") {
                    this.isPassedName = true;
                    this.isPassedNameError = "Please enter name";
                    this.message = "";
                    this.isSubmitting = false;
                }
                else {
                    this.isPassedName = false;
                    this.isPassedNameError = "";
                }
                if (this.passedAddress1 == "") {
                    this.isPassedAddress1 = true;
                    this.isPassedAddress1Error = "Please enter Address";
                    this.message = "";
                    this.isSubmitting = false;
                }
                else {
                    this.isPassedAddress1 = false;
                    this.isPassedAddress1Error = "";
                }


                if (this.passedCity == "") {
                    this.isPassedCity = true;
                    this.isPassedCityError = "Please enter City";
                    this.message = "";
                    this.isSubmitting = false;
                }
                else {
                    this.isPassedCity = false;
                    this.isPassedCityError = "";
                }


                if (this.passedZipCode == "") {
                    this.isPassedZipCode = true;
                    this.isPassedZipCodeError = "Please enter zip code";
                    this.message = "";
                    this.isSubmitting = false;
                }
                else {
                    this.isPassedZipCode = false;
                    this.isPassedZipCodeError = "";
                }
                if (this.passedCountry == "") {
                    this.isPassedCountry = true;
                    this.isPassedCountryError = "Please select country";
                    this.message = "";
                    this.isSubmitting = false;
                }
                else {
                    this.isPassedCountry = false;
                    this.isPassedCountryError = "";
                }

                if (!this.isEnrollmentRequestType && !this.isOptionalInfo && !this.isNamePreference && !this.isPassedName && !this.isPassedAddress1 && !this.isPassedCity && !this.isPassedZipCode && !this.isPassedCountry) {
                    fetch('/api/StudentAPI/SaveEnrollmentTranscript', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            RequestType: numericValue,
                            EnrollmentOptionalInfo: this.selectedOptions,
                            NamePreference: this.namePreference,
                            BasketId: this.passedBasketId,
                            Name: this.passedName,
                            Address1: this.passedAddress1,
                            Address2: this.passedAddress2,
                            Address3: this.passedAddress3,
                            City: this.passedCity,
                            State: this.passedState,
                            ZipCode: this.passedZipCode,
                            Country: this.passedCountry,
                            Comments: this.passedMailComments,
                            EmailAddress: "",
                            SendEmail: this.isSendEmail,
                        })
                    })
                        .then(response => {
                            if (response.ok) {
                                return response.json()
                            }
                        }).then(response => {
                            this.isSubmitting = false;
                            if (response.isSuccess) {
                                this.isSuccessMessage = true;
                                window.location.href = BasketCartUrl;
                            } else if (!response.isSuccess && response.checkoutTypeError) {
                                this.checkOutMessage = response.message
                                document.getElementById('btnCartCheckOutError').click();
                            } 
                            else {
                                this.isSuccessMessage = false;
                                this.message = "Something went wrong";
                            }

                        });
                }
            }
        },
        init() {
            this.ClearBalancePaymentBasket();
            this.getStates();
            this.getCountries();
            this.passedBasketId = document.getElementById("BasketId").value;


        }
    }
}